import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NavbarNotification from 'components/Navbars/NavbarNotification'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  ListGroup,
  Row,
  UncontrolledDropdown,
} from 'reactstrap'
import { increaseLimit } from 'store/Notifications/actions'
import {
  fetchNotifications,
  markAsRead,
  removeNotifications,
  setFilteredTypes,
  toggleReadFilter,
  toggleUnreadFilter,
} from 'store/Notifications/actions'

function Notifications() {
  const [selectedAlerts, setSelectedAlerts] = useState([])

  const {
    notifications,
    unreadFilter,
    readFilter,
    filteredTypes,
    limit,
    totalNotifications,
  } = useSelector((store) => store.notification)

  const { user } = useSelector((state) => state.auth)

  const filteredNotifications = notifications
    ?.filter(
      (notification) =>
        filteredTypes.length === 0 || filteredTypes.includes(notification.type)
    )
    ?.filter((notification) => {
      if (readFilter || unreadFilter) {
        if (readFilter) {
          return notification.read === 1
        } else {
          return notification.read === 0
        }
      } else {
        return true
      }
    })

  const unReadNotifications = filteredNotifications?.filter(
    (notification) => !notification.read
  )?.length

  const dispatch = useDispatch()

  const handleCheckboxChange = (id) => {
    if (selectedAlerts.includes(id)) {
      setSelectedAlerts(selectedAlerts.filter((i) => i !== id))
    } else {
      setSelectedAlerts([...selectedAlerts, id])
    }
  }

  const handleMarkAllAsRead = (unread = false) => {
    const userConfirmed =
      !unread &&
      window.confirm('Are you sure you want to proceed with this action?')

    if (!userConfirmed && !unread) {
      return
    }

    dispatch(markAsRead(selectedAlerts, selectedAlerts.length === 0, unread))
    setSelectedAlerts([])
  }

  const handleRemove = () => {
    const userConfirmed = window.confirm(
      'Are you sure you want to remove all notifications?'
    )

    if (!userConfirmed) {
      return
    }

    dispatch(removeNotifications(selectedAlerts, selectedAlerts.length === 0))
    setSelectedAlerts([])
  }

  const setTypeFilters = (types) => {
    const allTypesPresent = types.every((type) => filteredTypes.includes(type))

    if (!allTypesPresent) {
      dispatch(setFilteredTypes(types))
    } else {
      const updatedFilteredTypes = filteredTypes.filter(
        (type) => !types.includes(type)
      )
      dispatch(setFilteredTypes(updatedFilteredTypes))
    }
    setSelectedAlerts([])
  }

  useEffect(() => {
    dispatch(fetchNotifications())
  }, [dispatch])

  return (
    <Container className='mt--6' fluid>
      <Row className='justify-content-center'>
        <Col className='card-wrapper' lg='8'>
          <Card style={{ overflow: 'visible' }}>
            <CardHeader className='d-flex justify-content-between align-items-center card-header-responsive'>
              <UncontrolledDropdown>
                <DropdownToggle
                  className='btn btn-info ml-1'
                  style={{ padding: '0.625rem 1.25rem', fontSize: '14px' }}
                  role='button'
                  size='sm'
                  color=''
                >
                  Filter By
                </DropdownToggle>
                <DropdownMenu className='dropdown-menu-arrow' left>
                  <DropdownItem onClick={() => dispatch(toggleReadFilter())}>
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>Read</span>
                      {readFilter && <FontAwesomeIcon icon={faCheck} />}
                    </div>
                  </DropdownItem>
                  <DropdownItem onClick={() => dispatch(toggleUnreadFilter())}>
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>Unread</span>
                      {unreadFilter && <FontAwesomeIcon icon={faCheck} />}
                    </div>
                  </DropdownItem>
                  <DropdownItem onClick={() => setTypeFilters([1])}>
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>Course Promoted</span>
                      {filteredTypes.includes(1) && (
                        <FontAwesomeIcon icon={faCheck} />
                      )}
                    </div>
                  </DropdownItem>
                  <DropdownItem onClick={() => setTypeFilters([2, 3])}>
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>Added Courses & Groups</span>
                      {[2, 3].every((type) => filteredTypes.includes(type)) && (
                        <FontAwesomeIcon icon={faCheck} />
                      )}
                    </div>
                  </DropdownItem>
                  <DropdownItem onClick={() => setTypeFilters([4, 5])}>
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>Graded quizzes & certified courses</span>
                      {[4, 5].every((type) => filteredTypes.includes(type)) && (
                        <FontAwesomeIcon icon={faCheck} className='ml-2' />
                      )}
                    </div>
                  </DropdownItem>
                  <DropdownItem onClick={() => setTypeFilters([6])}>
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>Expired courses & progress resets</span>
                      {filteredTypes.includes(6) && (
                        <FontAwesomeIcon icon={faCheck} className='ml-2' />
                      )}
                    </div>
                  </DropdownItem>
                  {[1, 2, 4, 5].includes(user?.access) && (
                    <>
                      <DropdownItem onClick={() => setTypeFilters([8])}>
                        <div className='d-flex justify-content-between align-items-center'>
                          <span>Pending Checklists</span>
                          {filteredTypes.includes(8) && (
                            <FontAwesomeIcon icon={faCheck} className='ml-2' />
                          )}
                        </div>
                      </DropdownItem>
                      <DropdownItem onClick={() => setTypeFilters([9])}>
                        <div className='d-flex justify-content-between align-items-center'>
                          <span>Pending Quizzes</span>
                          {filteredTypes.includes(9) && (
                            <FontAwesomeIcon icon={faCheck} className='ml-2' />
                          )}
                        </div>
                      </DropdownItem>
                    </>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
              <div className='tabs-container'>
                {filteredNotifications?.length ? (
                  <Button
                    className='ml-3 btn btn-danger'
                    onClick={handleRemove}
                  >
                    {selectedAlerts.length === 0 ? 'Remove All' : 'Remove'}
                  </Button>
                ) : null}
                {selectedAlerts.length >= 1 ? (
                  <Button onClick={() => handleMarkAllAsRead(true)}>
                    {'Mark as unread'}
                  </Button>
                ) : (
                  ''
                )}
                {filteredNotifications?.length ? (
                  <Button onClick={() => handleMarkAllAsRead()}>
                    {selectedAlerts.length === 0
                      ? 'Mark all as read'
                      : 'Mark as read'}
                  </Button>
                ) : null}
              </div>
            </CardHeader>
            <div className='px-3 pt-3'>
              {notifications?.length && !readFilter ? (
                <h6 className='text-sm text-muted m-0'>
                  You have{' '}
                  <strong className='text-info'>
                    {unReadNotifications === 6 ? '5+' : unReadNotifications}
                  </strong>{' '}
                  unread{' '}
                  {unReadNotifications == 1 ? 'notification' : 'notifications'}.
                </h6>
              ) : null}
            </div>
            <CardBody
              style={{
                marginRight: '15px',
                marginLeft: '15px',
              }}
            >
              <ListGroup flush>
                {filteredNotifications?.map((notification) => (
                  <>
                    <div
                      key={notification.id}
                      className='d-flex align-items-center mb-2 bg-lighter'
                      style={{ borderRadius: '10px' }}
                    >
                      <div>
                        <Input
                          type='checkbox'
                          className='custom-control-input'
                          id={`customCheckNotification-${notification.id}`}
                          checked={selectedAlerts.includes(notification.id)}
                          onChange={() => handleCheckboxChange(notification.id)}
                        />
                        <label
                          className='custom-control-label checkbox-position user-select-none'
                          htmlFor={`customCheckNotification-${notification.id}`}
                        ></label>
                      </div>

                      <NavbarNotification
                        notification={notification}
                        selectedAlerts={selectedAlerts}
                      />
                    </div>
                  </>
                ))}
              </ListGroup>
              {totalNotifications > limit && (
                <div className='d-flex justify-content-center my-3'>
                  <Button
                    onClick={() => {
                      dispatch(increaseLimit())
                      dispatch(fetchNotifications())
                    }}
                  >
                    Load More
                  </Button>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default Notifications
